import {AxiosResponse} from 'axios';
import ActionSpinner from "../components/common/ActionSpinner";
import axios from "axios";
import AuthUtils from "../AuthUtils";
import {actions} from "../reducers/auth";
import Axios from "../config/Axios";

export const mySelf = async (useBaseUrl: boolean): Promise<AxiosResponse> => {
    return await ActionSpinner.get(`user/myself`, {}, {key: "mySelf", showOnError: false}, useBaseUrl)
};

export const logInKeycloack = async (username: string, password: string): Promise<AxiosResponse> => {
    let details = {
        'client_id': `${process.env.KEYCLOAK_CLIENT_ID}`,
        'username': username,
        'password': password,
        'grant_type': "password"
    };

    return await ActionSpinner.postPurePath(`${process.env.KEYCLOAK_URL}/auth/realms/${process.env.KEYCLOAK_REALM_NAME}/protocol/openid-connect/token`,
        AuthUtils.objectToEncodedRequestBody(details), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }, {key: "logInKeycloack", showOnError: true});
};

export const refreshAccessToken = async(): Promise<AxiosResponse> => {
    let details = {
        'client_id': `${process.env.KEYCLOAK_CLIENT_ID}`,
        'grant_type': "refresh_token",
        'refresh_token': AuthUtils.getRefreshToken()
    };

    return axios.post(`${process.env.KEYCLOAK_URL}/auth/realms/${process.env.KEYCLOAK_REALM_NAME}/protocol/openid-connect/token`,
        AuthUtils.objectToEncodedRequestBody(details), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};

export const activateUser = async(key: string, password: string): Promise<AxiosResponse> => {
    return await ActionSpinner.post(
        `public/user/activate?key=${key}`, { "newPassword": password }, {},
        {
            key: "activateUser",
            showOnSuccess: true,
            showOnError: true,
            onSuccessMessage: "User activated successfully."
        })
};

export const setApplicationLocale = (locale: { label: string, value: string }) => {
    return (dispatch: any) => {
        dispatch({type: actions.SET_APPLICATION_LOCALE, payload: locale})
    }
};

export const updateUserLocale = async (localeTag: string): Promise<AxiosResponse> => {
    return Axios.instanceV2.post(`user/locale?locale=${localeTag}`);
};


// WEBPACK FOOTER //
// ./app/actions/authActions.ts